import React from "react";
import { API_SIDEBAR, SectionId } from "./SidebarConfig";

interface ApiSidebarProps {
  active: SectionId;
  onChange: (id: SectionId) => void;
}

export const ApiSidebar: React.FC<ApiSidebarProps> = ({
  active,
  onChange,
}) => (
  <aside className="w-60 shrink-0 border-r border-gray-200 h-screen overflow-y-auto">
    
    {/* Header */}
    <div className="px-4 pt-5 pb-3">
      <p className="text-sm font-bold tracking-wide text-gray-500 uppercase">
        API Reference
      </p>
    </div>

    {/* Groups */}
    {API_SIDEBAR.map((group) => (
      <div key={group.group} className="mb-4">
        
        {/* Group Title */}
        <p className="px-4 py-1 text-xs font-bold tracking-wide text-gray-500 uppercase">
          {group.group}
        </p>

        <div className="relative">
          {group.items.map((item) => {
            const isActive = item.id && active === item.id;

            // ✅ Parent label (non-clickable)
            if (item.isParent) {
              return (
                <div
                  key={item.label}
                  className="px-4 py-2 text-sm text-gray-500"
                >
                  {item.label}
                </div>
              );
            }

            return (
              <div key={item.id} className="relative">
                
                {/* 🔵 Vertical blue line */}
                {item.isChild && (
                  <span className="absolute left-5 top-0 bottom-0 w-px bg-brand-main/30" />
                )}

                <button
                  onClick={() => item.id && onChange(item.id)}
                  className={`
                    w-full text-left transition-all duration-150 border-r-2 relative
                    
                    ${
                      item.isChild
                        ? "pl-10 py-1.5 text-sm"
                        : "px-4 py-2 text-sm"
                    }
                    
                    ${
                      isActive
                        ? "bg-gray-100 text-brand-main border-brand-main"
                        : "text-gray-700 hover:bg-gray-100 hover:text-gray-900 border-transparent"
                    }
                  `}
                >
                  
                  {/* 🔵 Connector dash */}
                  {item.isChild && (
                    <span className="absolute left-5 top-1/2 -translate-y-1/2 w-3 h-px bg-brand-main/40" />
                  )}

                  {item.label}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    ))}
  </aside>
);